/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ part: "afternoon" | "morning" | "night" }} Today_Greeting_PartInputs */

const en_us2_today_greeting_part = /** @type {(inputs: Today_Greeting_PartInputs) => LocalizedString} */ (i) => {
	if (i?.part === "morning") return /** @type {LocalizedString} */ (`Good morning`);
	if (i?.part === "afternoon") return /** @type {LocalizedString} */ (`Good afternoon`);
	if (i?.part === "night") return /** @type {LocalizedString} */ (`Good evening`);
	return /** @type {LocalizedString} */ ("today.greeting_part");
};

const pt_br2_today_greeting_part = /** @type {(inputs: Today_Greeting_PartInputs) => LocalizedString} */ (i) => {
	if (i?.part === "morning") return /** @type {LocalizedString} */ (`Bom dia`);
	if (i?.part === "afternoon") return /** @type {LocalizedString} */ (`Boa tarde`);
	if (i?.part === "night") return /** @type {LocalizedString} */ (`Boa noite`);
	return /** @type {LocalizedString} */ ("today.greeting_part");
};

const es_419_today_greeting_part = /** @type {(inputs: Today_Greeting_PartInputs) => LocalizedString} */ (i) => {
	if (i?.part === "morning") return /** @type {LocalizedString} */ (`Buenos días`);
	if (i?.part === "afternoon") return /** @type {LocalizedString} */ (`Buenas tardes`);
	if (i?.part === "night") return /** @type {LocalizedString} */ (`Buenas noches`);
	return /** @type {LocalizedString} */ ("today.greeting_part");
};

const pt_pt2_today_greeting_part = /** @type {(inputs: Today_Greeting_PartInputs) => LocalizedString} */ (i) => {
	if (i?.part === "morning") return /** @type {LocalizedString} */ (`Bom dia`);
	if (i?.part === "afternoon") return /** @type {LocalizedString} */ (`Boa tarde`);
	if (i?.part === "night") return /** @type {LocalizedString} */ (`Boa noite`);
	return /** @type {LocalizedString} */ ("today.greeting_part");
};

const fr_fr2_today_greeting_part = /** @type {(inputs: Today_Greeting_PartInputs) => LocalizedString} */ (i) => {
	if (i?.part === "morning") return /** @type {LocalizedString} */ (`Bonjour`);
	if (i?.part === "afternoon") return /** @type {LocalizedString} */ (`Bon après-midi`);
	if (i?.part === "night") return /** @type {LocalizedString} */ (`Bonsoir`);
	return /** @type {LocalizedString} */ ("today.greeting_part");
};

const de_de2_today_greeting_part = /** @type {(inputs: Today_Greeting_PartInputs) => LocalizedString} */ (i) => {
	if (i?.part === "morning") return /** @type {LocalizedString} */ (`Guten Morgen`);
	if (i?.part === "afternoon") return /** @type {LocalizedString} */ (`Guten Tag`);
	if (i?.part === "night") return /** @type {LocalizedString} */ (`Guten Abend`);
	return /** @type {LocalizedString} */ ("today.greeting_part");
};

const it_it2_today_greeting_part = /** @type {(inputs: Today_Greeting_PartInputs) => LocalizedString} */ (i) => {
	if (i?.part === "morning") return /** @type {LocalizedString} */ (`Buongiorno`);
	if (i?.part === "afternoon") return /** @type {LocalizedString} */ (`Buon pomeriggio`);
	if (i?.part === "night") return /** @type {LocalizedString} */ (`Buonasera`);
	return /** @type {LocalizedString} */ ("today.greeting_part");
};

/**
* | part | output |
* | --- | --- |
* | "morning" | "Good morning" |
* | "afternoon" | "Good afternoon" |
* | "night" | "Good evening" |
*
* @param {Today_Greeting_PartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_greeting_part = /** @type {((inputs: Today_Greeting_PartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Greeting_PartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_greeting_part(inputs)
	if (locale === "es-419") return es_419_today_greeting_part(inputs)
	if (locale === "pt-PT") return pt_pt2_today_greeting_part(inputs)
	if (locale === "fr-FR") return fr_fr2_today_greeting_part(inputs)
	if (locale === "de-DE") return de_de2_today_greeting_part(inputs)
	if (locale === "it-IT") return it_it2_today_greeting_part(inputs)
	return en_us2_today_greeting_part(inputs)
});
export { today_greeting_part as "today.greeting_part" }